import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { NavbarHeightProvider } from './helpers/NavbarHeightContext'; // A wrapper to let the App to use the navi bar height

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <>
        <QueryClientProvider client={queryClient}>
            <NavbarHeightProvider>
                <App/>
            </NavbarHeightProvider>
            <ReactQueryDevtools />
        </QueryClientProvider>
    </>,
);
